/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MonitorCreationSpec { 
    deployment_id: string;
    monitor_version?: MonitorCreationSpec.MonitorVersionEnum;
    org_id: string;
}
export namespace MonitorCreationSpec {
    export type MonitorVersionEnum = 'V1';
    export const MonitorVersionEnum = {
        V1: 'V1' as MonitorVersionEnum
    };
}


